import React from 'react'
import Head, { PageHead as ZionPageHead } from '@fs/zion-head'
import { i18n } from '@fs/zion-locale'
import { getSchemaOrgPage, getSchemaOrgPerson } from '../services/web-page-schema'
import type { Person } from '../types/persons'
import type { Families } from '../types/data-types'

function sanitizeJSON(unsanitized: string | undefined): string | undefined {
  return unsanitized?.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

export default function PageHead({
  title,
  description,
  socialShareDescription,
  url,
  image,
  person,
  families,
}: {
  title: string
  description: string
  socialShareDescription?: string
  url?: string
  image?: { url: string; alt: string; width: number; height: number }
  person?: Person
  families?: Families
}): JSX.Element {
  const ogDescription = socialShareDescription || description

  const jsonld = person && families ? getSchemaOrgPerson(person, families) : undefined
  const webPageJsonld = getSchemaOrgPage(i18n.language, title, ogDescription, person)
  return (
    <>
      <ZionPageHead
        title={title}
        description={description}
        type="profile"
        socialShareDescription={socialShareDescription}
        image={image}
        url={url}
      />
      <Head>
        <meta property="fb:admins" content="1047550305" />
        {jsonld !== undefined && <script type="application/ld+json">{sanitizeJSON(JSON.stringify(jsonld))}</script>}
        <script type="application/ld+json">{sanitizeJSON(JSON.stringify(webPageJsonld))}</script>
      </Head>
    </>
  )
}
